export class StrengthTestResult {
  _id?: string;
  sampleId?: string;
  sampleType?: string;
  sampleDate?: Date;
  concrete?: string;
  concreteMetadata?: ConcreteMetadata;
  freshConcreteMetadata?: FreshConcreteMetadata;
  strengthTestResult?: StrengthTestItem[];
  processingJob?: string[];
  sourcePour?: string;
  pourDeliveryNoteId?: string;
  linkMetadata?: StrengthTestLinkMetadata;
  completionLog?: CompletionLogEntry[];
  company?: string;
  project?: string;
  linked?: boolean;
  controlLot?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ConcreteMetadata {
  concreteType?: string;
  cementType?: string;
  cementContent?: number;
  waterCementRatio?: number;
  manufacturingTime?: string;
  truckLicensePlate?: string;
  deliveryNote?: string;
  supplier?: string;
}

export interface FreshConcreteMetadata {
  ambientTemp?: number;
  concreteTemp?: number;
  dischargeTime?: string;
  slump?: number[];
  slumpAvg?: number;
}

export interface StrengthTestItem {
  testDate?: Date;
  testAge?: number;
  strengthResult?: number;
}

export interface StrengthTestLinkMetadata {
  linkedVia?: 'recommendation' | 'manual';
  confidence?: 'high' | 'medium' | null;
  linkedAt?: Date;
  recommendedPourIds?: string[];
}

export interface CompletionLogEntry {
  field: string;
  value: any;
  addedAt: Date;
  addedBy: string;
}
